(function () {
  var rootSelector = '[data-meetup-wall]';
  var videoSelector = '[data-meetup-wall-video]';
  var communityRootSelector = '[data-community-wall]';
  var communitySetSelector = '.community-wall__set';
  var communityItemAttribute = 'data-community-wall-item';
  var state = window.WellWiseMeetupWall || {
    roots: new WeakSet(),
    observers: new WeakMap()
  };

  window.WellWiseMeetupWall = state;

  function getRoots(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var roots = [];

    if (scope.matches && scope.matches(rootSelector)) {
      roots.push(scope);
    }

    return roots.concat(Array.prototype.slice.call(scope.querySelectorAll(rootSelector)));
  }

  function playVideo(video) {
    video.muted = true;

    var playPromise = video.play();

    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {});
    }
  }

  function shouldReduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getCommunityItems(set) {
    return Array.prototype.slice.call(set.children).filter(function (child) {
      return child.hasAttribute(communityItemAttribute);
    });
  }

  function shuffleOrder(order) {
    var shuffled = order.slice();

    for (var index = shuffled.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var currentValue = shuffled[index];

      shuffled[index] = shuffled[randomIndex];
      shuffled[randomIndex] = currentValue;
    }

    return shuffled;
  }

  function shuffleCommunityWall(root) {
    if (!root.matches || !root.matches(communityRootSelector) || root.dataset.communityWallShuffled === 'true') {
      return;
    }

    var sets = Array.prototype.slice.call(root.querySelectorAll(communitySetSelector));

    if (sets.length < 2) {
      return;
    }

    var order = getCommunityItems(sets[0]).map(function (item) {
      return item.getAttribute(communityItemAttribute);
    });

    if (order.length < 2) {
      return;
    }

    order = shuffleOrder(order);

    sets.forEach(function (set) {
      var itemsByKey = {};

      getCommunityItems(set).forEach(function (item) {
        itemsByKey[item.getAttribute(communityItemAttribute)] = item;
      });

      order.forEach(function (key) {
        if (itemsByKey[key]) {
          set.appendChild(itemsByKey[key]);
        }
      });
    });

    root.dataset.communityWallShuffled = 'true';
  }

  function initRoot(root) {
    if (state.roots.has(root)) {
      return;
    }

    state.roots.add(root);
    shuffleCommunityWall(root);

    var videos = Array.prototype.slice.call(root.querySelectorAll(videoSelector));

    if (!videos.length) {
      return;
    }

    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
    });

    if (shouldReduceMotion()) {
      videos.forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playVideo);
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          playVideo(video);
          return;
        }

        video.pause();
      });
    }, {
      root: null,
      rootMargin: '18% 24%',
      threshold: 0.08
    });

    videos.forEach(function (video) {
      observer.observe(video);
    });

    state.observers.set(root, observer);
  }

  function unloadRoot(root) {
    var observer = state.observers.get(root);

    if (observer) {
      observer.disconnect();
      state.observers.delete(root);
    }

    root.querySelectorAll(videoSelector).forEach(function (video) {
      video.pause();
    });
  }

  function init(context) {
    getRoots(context).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getRoots(event.target).forEach(unloadRoot);
  });
})();
